import { useTranslation } from 'react-i18next';
import { PageLayout } from 'src/common/components/AppLayout/PageLayout';
import { TablePageTitle } from 'src/common/components/AppLayout/TablePage/TablePageTitle';
import { SimProfilesTabLayout } from './SimProfilesTabLayout';

const SimProfilesPageTitle = () => {
  const { t } = useTranslation();

  return <TablePageTitle>{t('simProfiles.profiles')}</TablePageTitle>;
};

export const SimProfilesPageLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <PageLayout title={<SimProfilesPageTitle />}>
      <SimProfilesTabLayout>{children}</SimProfilesTabLayout>
    </PageLayout>
  );
};
